export const OIDC_CONSTANTS = {
  PROVIDER_ID: 'smartclub',
  PROVIDER_NAME: 'smartclub',
}

export const SMART_CLUB_URL = process.env.NEXT_PUBLIC_SMART_CLUB_URL
export const SIGN_UP_URL = `${process.env.NEXT_PUBLIC_SMART_CLUB_URL}/mypage/register?register_route=stay`
export const OIDC_WELLKNOWN_URL = `${process.env.NEXT_PUBLIC_SMART_CLUB_URL}/.well-known/openid-configuration`

export const OLD_TRIPLA_SIGN_IN_GRANT_TYPE = 'authorization_code'
export const TRIPLA_WEB_SSO_ID = 3
export const TRIPLA_OPEN_ID_SIGN_IN_LOCALE = 'en'

export const SESSION_COOKIE_NAME = process.env.NEXTAUTH_URL?.startsWith(
  'https://',
)
  ? '__Secure-next-auth.session-token'
  : 'next-auth.session-token'
